import { Outlet } from "react-router-dom";

/**
 * Anciennement : bloquait les mobiles.
 * Le parcours Maillon Faible est prévu smartphone — on laisse passer.
 */
const PlayerRoute = ({ children }) => children ?? <Outlet />;

export default PlayerRoute;
